import React, { Fragment, useContext } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Grid,
  Paper,
  Avatar,
  Typography,
  Link,
  Divider,
  Button,
} from "@material-ui/core";
import CheckCircleRoundedIcon from "@material-ui/icons/CheckCircleRounded";
// import ArrowDropDownRoundedIcon from "@material-ui/icons/ArrowDropDownRounded";
import WallpaperRoundedIcon from "@material-ui/icons/WallpaperRounded";

// Contexts
import OrderContext from "../../../../context/orders/v1/OrdersContext";

const useStyles = makeStyles((theme) => ({
  paper: {
    marginBottom: theme.spacing(2),
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
    fontSize: "0.9rem",
  },
  avatar: {
    width: theme.spacing(4),
    height: theme.spacing(4),
    color: "white",
  },
  rowBottom: {
    marginBottom: "1rem",
  },
  // lineItemBox: {
  //   height: "4.5rem",
  // },
  title: {
    color: theme.palette.text.primary,
    fontWeight: "bold",
    marginTop: "0.3rem",
  },
  title2: {
    marginTop: "0.5rem",
  },
  image: {
    width: 50,
    border: "1px solid whitesmoke",
  },
  divider: {
    marginTop: "1rem",
    marginBottom: "1rem",
  },
  button: {
    textTransform: "none",
  },
  textLeft: {
    textAlign: "left",
  },
}));

const OrderEditItemFulfilled = ({
  getImage,
  setCurrentFulfilled,
  fulfilledItems,
  products,
}) => {
  const classes = useStyles();
  const { setModal } = useContext(OrderContext);

  return (
    fulfilledItems.length > 0 && (
      <Grid
        container
        direction="column"
        alignitem="center"
        justifyContent="flex-start"
      >
        {" "}
        {fulfilledItems.map((fulfillment, index) => {
          let total_items = 0;

          fulfillment.line_items.map((each) => {
            total_items += each.quantity;
          });

          return (
            <Paper key={index} className={classes.paper}>
              {" "}
              {/* Title */}{" "}
              <Grid
                item
                xs={12}
                container
                direction="row"
                alignitem="flex-end"
                justifyContent="flex-start"
                className={classes.rowBottom}
              >
                <Grid item>
                  <Avatar
                    className={classes.avatar}
                    style={{
                      backgroundColor: "green",
                    }}
                  >
                    <CheckCircleRoundedIcon />
                  </Avatar>{" "}
                </Grid>{" "}
                & ensp;{" "}
                <Grid item>
                  <Typography variant="body1" className={classes.title}>
                    {" "}
                    {/* Fulfilled ({fulfillment.line_items.length}) */}
                    Fulfilled({total_items}){" "}
                  </Typography>{" "}
                </Grid>{" "}
                & ensp;{" "}
                <Grid item>
                  <Typography variant="body2" className={classes.title2}>
                    {" "}
                    {fulfillment.name.replace(".", "-F")}{" "}
                  </Typography>{" "}
                </Grid>{" "}
              </Grid>
              {/* Tracking */}{" "}
              <Grid item xs={12} container>
                <Typography variant="body2">
                  {" "}
                  {fulfillment.tracking_company}
                  tracking{" "}
                </Typography>{" "}
              </Grid>{" "}
              <Grid item xs={12} container className={classes.rowBottom}>
                <Typography variant="body2">
                  <Link
                    href={
                      fulfillment.tracking_url ? fulfillment.tracking_url : ""
                    }
                    target="_blank"
                    rel="noopener"
                  >
                    {" "}
                    {fulfillment.tracking_number
                      ? fulfillment.tracking_number
                      : ""}{" "}
                  </Link>{" "}
                </Typography>{" "}
              </Grid>
              <Divider className={classes.divider} orientation="horizontal" />
              {/* Items */}{" "}
              {fulfillment.line_items.map((item, index) => {
                const image =
                  products[item.product_id] &&
                  getImage(item.variant_id, products[item.product_id]);

                return (
                  <Fragment key={index}>
                    <Grid
                      item
                      xs={12}
                      container
                      direction="row"
                      alignitem="center"
                      justifyContent="space-between"
                      className={classes.lineItemBox}
                    >
                      <Grid
                        item
                        xs={2}
                        container
                        direction="column"
                        alignItems="center"
                        justifyContent="center"
                      >
                        {" "}
                        {image ? (
                          <img className={classes.image} src={image} />
                        ) : (
                          <WallpaperRoundedIcon fontSize="large" />
                        )}{" "}
                      </Grid>
                      <Grid
                        item
                        xs={6}
                        container
                        direction="column"
                        alignItems="flex-start"
                        justifyContent="center"
                        className={classes.textLeft}
                      >
                        <Grid item> {item.title} </Grid>{" "}
                        <Grid item> {item.variant_title} </Grid>{" "}
                        <Grid item> SKU: {item.sku} </Grid>{" "}
                      </Grid>
                      <Grid
                        item
                        xs={2}
                        container
                        direction="column"
                        alignItems="center"
                        justifyContent="center"
                      >
                        $ {item.price} & ensp; x & ensp; {item.quantity}{" "}
                      </Grid>
                      <Grid
                        item
                        xs={2}
                        container
                        direction="column"
                        alignItems="center"
                        justifyContent="center"
                      >
                        ${" "}
                        {(
                          parseFloat(item.price) * parseFloat(item.quantity)
                        ).toFixed(2)}{" "}
                      </Grid>{" "}
                    </Grid>

                    <Divider
                      className={classes.divider}
                      orientation="horizontal"
                    />
                  </Fragment>
                );
              })}
              {/* More Button */}{" "}
              <Grid
                item
                xs={12}
                container
                direction="row"
                alignitem="center"
                justifyContent="flex-end"
              >
                <Button
                  variant="contained"
                  color="primary"
                  className={classes.button}
                  onClick={() => {
                    setModal(true, "tracking");
                    setCurrentFulfilled(fulfillment);
                  }}
                >
                  {" "}
                  {fulfillment.tracking_number
                    ? "Edit Tracking"
                    : "Add Tracking"}{" "}
                </Button>{" "}
              </Grid>{" "}
            </Paper>
          );
        })}{" "}
      </Grid>
    )
  );
};

export default OrderEditItemFulfilled;
